import { render } from "./AdminViewingReport.vue?vue&type=template&id=5068dc02"
import script from "./AdminViewingReport.vue?vue&type=script&lang=js"
export * from "./AdminViewingReport.vue?vue&type=script&lang=js"

import "./AdminViewingReport.vue?vue&type=style&index=0&id=5068dc02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__